import { useEffect, useState } from "react";
import QRCode from "qrcode";
import "./QRCorner.css";

// Card #1641 (design §6.2/§6.3) — renders inside ScoreboardFrame's `qrSlot`
// on QR-capable mode types (modeTypes.js's isQrCapableModeType, the FE-owned
// gate — mirrors SponsorStrip/sponsorVariantForModeType's pattern). Generates
// the QR code CLIENT-SIDE (design §6.3: "Generated client-side... with a
// small dependency (qrcode, canvas/SVG output) — no API surface, no
// storage") from a plain `url` prop the caller (ScoreboardPage) builds,
// encoding the public class-results page `/results/:showId/:year/:classNumber`
// (§4.1; #1854 renamed the param classId -> classNumber, a short
// human-readable class number rather than the internal fvd: classId) a
// rider's phone camera decodes straight off the board/projector.
//
// Rendered on a solid white backing plate REGARDLESS of the board's own
// theme: the point is camera-scannability from across a room, and a theme's
// background/text colors (arbitrary per design §2.1) can't be trusted to
// hold the black-on-light contrast a QR decoder needs.
export default function QRCorner({ url }) {
  const [dataUrl, setDataUrl] = useState(null);

  useEffect(() => {
    let active = true;
    if (!url) {
      setDataUrl(null);
      return undefined;
    }
    QRCode.toDataURL(url, { margin: 1, width: 256 })
      .then((generated) => {
        if (active) setDataUrl(generated);
      })
      .catch(() => {
        if (active) setDataUrl(null);
      });
    return () => {
      active = false;
    };
  }, [url]);

  // No url, or generation hasn't resolved (or failed) yet — render nothing
  // rather than a broken/placeholder image; the slot is empty either way in
  // ScoreboardFrame until this has a real code to show.
  if (!url || !dataUrl) return null;

  return (
    <div className="qr-corner" data-testid="qr-corner">
      <img src={dataUrl} alt="Scan for class results" className="qr-corner__image" />
    </div>
  );
}
